import { render, staticRenderFns } from "./KitchenSinkPlantFormGroup.vue?vue&type=template&id=7dcb32d6&"
import script from "./KitchenSinkPlantFormGroup.vue?vue&type=script&lang=ts&"
export * from "./KitchenSinkPlantFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports